import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export class CustomerRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (this.routePath(future) === 'group' && this.routePath(curr) === 'group') {
      return false;
    }

    return future.routeConfig === curr.routeConfig;
  }

  private routePath(route: ActivatedRouteSnapshot): string {
    const segments: string[] = [];
    let current: ActivatedRouteSnapshot | null = route;

    while (current) {
      segments.unshift(...current.url.map((segment) => segment.path));
      current = current.parent;
    }

    return segments.join('/');
  }
}
